export const emptyTablePresets = {
    TableCell: {
        numeric: {},
    },
    TablePagination: {
        atlasTablePagination: {},
    },
};
//# sourceMappingURL=table.js.map